import AffirmPaymentWidget from './widgets/AffirmPaymentWidget';
import BraintreePaymentWidget from './widgets/BraintreePaymentWidget';

(function () {
  window.paymentWidgets = {
    affirm_fin: AffirmPaymentWidget,
    braintr_cc: BraintreePaymentWidget,
  };
}());



// WEBPACK FOOTER //
// ./Library/1.0/common/payment_widgets/payment-widgets.js